export default "__VITE_ASSET__SLF_iAlx__"